<template>
    <div :class="{sSub:!isColor,sMain:isColor}">
        <svg version="1.1" :viewBox="`0 0 ${viewWidth+SWidth*2} ${viewHeight+SWidth*2}`" :class="transformSvg"  v-show="dashLine" :style="`width:${viewWidth}px;height:${viewHeight}px`" >
            <path :d="polylines" class="polyline" :class="{polyLine:isAnimation}" fill="none" :stroke-width="SWidth" :stroke-dasharray="strokeDash"/>
            <polygon :points="polygonPoints" v-show="isArrow" :class="{fSub:!isColor,fMain:isColor}"/> 
        </svg>
        <svg version="1.1" :viewBox="`0 0 ${viewWidth} ${viewHeight}`"  v-show="!dashLine" :width="viewWidth" :style="`width:${viewWidth}px;height:${viewHeight}px`"  :class="[transfromLine,addClass]" >
            <line x1="0" :y1="viewHeight/2" :x2="viewWidth" :y2="viewHeight/2" :class="{polyLine:isAnimation}" :stroke-width="SWidth" :stroke-dasharray="strokeDash"/>
            <polygon :points="LinePoints" v-show="isArrow" :class="{fSub:!isColor,fMain:isColor}"/> 
        </svg>
   </div>
</template>
<script>
export default {
  name: 'poly-line',
  data(){
      return{
      }
  },
  props:{
    dashLine:{  //是否是折线还是直线
        type:Boolean,
        default:true
    },
    SWidth:{ //线条宽度
        type:Number,
        default:2
    },
    isColor:{
        type:Boolean,
        default:true
    },
    strokeDash:{ //曲线
        type:Number,
        default:5
    },
    viewWidth:{ //外宽
        type:Number,
        default:100
    },
    isArrow:{ //是否有箭头
        type:Boolean,
        default:true
    },
    viewHeight:{ //外高
        type:Number,
        default:100
    },
    addClass:{
        type:[String,Object],
        default: ""
    },
    isAnimation:{ //动画
        type:Boolean,
        default:true  
    },
    direction:{ //折线型方向
        type:String,
        default:"TR"
    },
    directionLine:{ //直线型方向
        type:String,
        default:""
    },
    radiusN:{
        type:Number,
        default:stage.space/2
    }
  },
  computed:{
    transformSvg(){
        if(this.direction=='BR'||this.direction=='LB') return 'trsX180'
        else if(this.direction=='RT'||this.direction=='TL') return 'trsY180'
        else if(this.direction=='BL'||this.direction=='RB') return 'trsZ180'
    },
    transfromLine(){
        if(this.directionLine=='RL') return 'trsZ180'
        if(this.directionLine=='TB') return 'trsZ90'
        if(this.directionLine=='BT') return 'trsZ-90'
    },
    polylines(){
        if(this.direction=='TR'||this.direction=='BR'||this.direction=='BL'||this.direction=='TL')return `M ${this.SWidth} ${this.SWidth} L ${this.SWidth} ${this.viewHeight-this.radiusN} q ${this.SWidth} ${this.radiusN} ${this.SWidth+this.radiusN} ${this.radiusN} M ${this.SWidth+this.radiusN} ${this.viewHeight} L ${this.viewWidth} ${this.viewHeight}`
        else return `M ${this.SWidth} ${this.viewHeight} L ${this.viewWidth-this.radiusN} ${this.viewHeight} q ${this.radiusN} 0 ${this.radiusN} -${this.radiusN} M ${this.viewWidth} ${this.viewHeight-this.radiusN} L ${this.viewWidth} ${this.SWidth}`
    },
    polygonPoints(){
        if(this.direction=='TR'||this.direction=='BR'||this.direction=='BL'||this.direction=='TL') return `${this.viewWidth-this.SWidth*2},${this.viewHeight-this.SWidth*2} ${this.viewWidth-this.SWidth},${this.viewHeight} ${this.viewWidth-this.SWidth*2},${this.viewHeight+this.SWidth*2} ${this.viewWidth+this.SWidth*2},${this.viewHeight}` 
        else return `${this.viewWidth-this.SWidth*2},${this.SWidth*4} ${this.viewWidth},${this.SWidth*3} ${this.viewWidth+this.SWidth*2},${this.SWidth*4} ${this.viewWidth},0`
    },
    LinePoints(){
         return `${this.viewWidth-this.SWidth*4},${this.viewHeight/2-this.SWidth*2} ${this.viewWidth-this.SWidth*3},${this.viewHeight/2} ${this.viewWidth-this.SWidth*4},${this.viewHeight/2+this.SWidth*2} ${this.viewWidth},${this.viewHeight/2}` 
    },
  }
}
</script>   
<style lang="scss" scoped>
.polyLine{ animation: dash .4s linear infinite; }
.trsX180{
    transform: rotateX(180deg);
}
.trsY180{
    transform: rotateY(180deg);
}
@for $i from -180 through 180 {
    .trsZ#{$i}{
        transform: rotateZ(#{$i}deg);
    }
}
@keyframes dash {
    to {
        stroke-dashoffset: -10;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/DashLine.vue